<div class="toggle-row">
  <div class="label" [ngClass]="{ active: messageType === MsgType.feedback }">Zpětné vazby</div>
  <ion-toggle [(ngModel)]="toggleValue" (ngModelChange)="toggleChanged($event)"></ion-toggle>
  <div class="label" [ngClass]="{ active: messageType === MsgType.direct }">Přímé zprávy</div>
</div>
